import React, { useState, useRef, useEffect } from "react";
import Colors from "../../Constants/Colors";
export default function InputComponent2({
  width,
  label,
  value,
  selected,
  setSelected,
  options,
  customWidth,
  customTop,
  isRequired,
  style,
  className,
  disable,
  icon,
  onChange,
}) {
  const [isActive, setIsActive] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState("");
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClick = (option) => {
    if (disable) return;
    setSelected(option.id);
    setIsActive(false);
    setSelectedLabel(option.label);
  };

  // ✅ NEW: Handle input change
  const handleInputChange = (e) => {
    if (onChange && !disable) {
      onChange(e);
    }
  };

  return (
    <div
      className={`dropdown-CB ${className}`}
      style={{ width, ...style }}
      ref={dropdownRef}
    >
      <label className="dropdown-CB-label">
        {label}
        {isRequired && <span>*</span>}
        {icon && (
          <img
            src={icon}
            alt="icon"
            style={{ marginLeft: "8px", width: "12px", height: "12px" }}
          />
        )}
      </label>

      {/* ✅ CHANGED: From <div> to <input> element */}
      <input
        ref={inputRef}
        type="text"
        className="dropdown-btn-input"
        value={value !== undefined && value !== null ? value : selectedLabel}
        onChange={handleInputChange}
        disabled={disable}
        style={{
          cursor: disable ? "not-allowed" : "text",
          backgroundColor: disable ? Colors.color10 : Colors.color14,
          color: Colors.color3,
          border: disable ? `1px solid ${Colors.color9}` : `1px solid ${Colors.color3}`,
          padding: "8px 12px",
          width: "100%",
          boxSizing: "border-box",
          fontSize: "14px",
          outline: "none",
        }}
        placeholder={disable ? "" : `Enter ${label}`}
      />
    </div>
  );
}
